import Navigation from './modules/Navigation.js';
import MobileNavigation from './modules/MobileNavigation.js';
import RemoveLink from './modules/RemoveLink.js';
import PaginationScroll from './modules/PaginationScroll.js';
import OnScrollRemoveArrowFade from './modules/onScrollRemoveArrowFade.js';


document.addEventListener('DOMContentLoaded', function() {
  Navigation();
  MobileNavigation();
  RemoveLink(); 
  PaginationScroll();
  OnScrollRemoveArrowFade();
});
